//UPLOAD
export const FETCH_VIDEO = "fetchvideo";
export const FETCH_STAGE = "fetchstage";
